import type { Theme } from '@mui/material/styles'

import { TinyBarChart } from '../../../common/components/TinyBarChart'
import type { CommonCopy } from '../../../core/types/localization/CommonCopy'
import { type Beat } from '../../../insights/types/CommonBeat'

import { buildChartData, buildDataSeries, type ChartDataProps } from '../../utils/Transactions'

export const BeatTemplates = {
  BILL_AMOUNT_NOT_STANDARD: 'BillAmountNotStandard',
}

export const getEmbeddedInstanceSlotByBeatTemplates = (copy: CommonCopy, beat?: Beat) => {
  if (beat) {
    switch (beat.template) {
      case BeatTemplates.BILL_AMOUNT_NOT_STANDARD: {
        const dataSeries = beat.data_series
          ? (buildDataSeries(beat.data_series) as ChartDataProps[])
          : []
        const chartData = buildChartData(dataSeries, beat.payload?.merchant_name)

        return {
          instanceSlot: (
            <TinyBarChart
              color={(theme: Theme) => {
                return theme.palette.categories.billsUtilities
              }}
              data={chartData.slice(-3)}
            />
          ),
          dataSeries,
          chartData,
          callToAction: copy.view_history,
        }
      }
      default: {
        return null
      }
    }
  }
  return null
}
